/**
 * ParkProof design tokens — clean, minimal palette with high contrast markers.
 */

export const colors = {
  // Surfaces - clean whites and grays
  page: '#FFFFFF',        // Pure white background
  card: '#FFFFFF',
  tint: '#F5F5F5',        // Very light gray for hover/selected
  deep: '#1A1A1A',        // Near black
  
  // Ink - good contrast grays
  ink1: '#1A1A1A',        // Primary text - near black
  ink2: '#4A4A4A',        // Secondary text
  ink3: '#7A7A7A',        // Muted text
  rule: '#E5E5E5',        // Light gray borders
  ruleSoft: '#F0F0F0',    // Subtle dividers

  // Tier colors - high contrast for map markers
  tierVerified: '#059669',      // Emerald green - map markers
  tierVerifiedBg: '#ECFDF5',    // Light green background for badges
  tierLikely: '#2563EB',        // Blue - map markers
  tierLikelyBg: '#EFF6FF',      // Light blue background for badges
  tierReported: '#F59E0B',      // Amber - map markers
  tierReportedBg: '#FFFBEB',    // Light amber background for badges
  tierUnknown: '#9CA3AF',       // Medium gray (was too dark) - map markers
  tierUnknownBg: '#F3F4F6',     // Light gray background for badges

  // Accent
  accent: '#2563EB',      // Blue accent for buttons/links
  accentDark: '#1D4ED8',

  white: '#FFFFFF',
  black: '#000000',
} as const;

export type Tier = 'verified' | 'likely' | 'reported' | 'unknown';

export const tierColor = (tier: Tier): { fg: string; bg: string; marker: string } => {
  switch (tier) {
    case 'verified':
      return { fg: colors.tierVerified, bg: colors.tierVerifiedBg, marker: colors.tierVerified };
    case 'likely':
      return { fg: colors.tierLikely, bg: colors.tierLikelyBg, marker: colors.tierLikely };
    case 'reported':
      return { fg: colors.tierReported, bg: colors.tierReportedBg, marker: colors.tierReported };
    case 'unknown':
      return { fg: colors.tierUnknown, bg: colors.tierUnknownBg, marker: '#6B7280' }; // Darker gray for unknown markers
  }
};

export const tierLabel = (tier: Tier): string => {
  switch (tier) {
    case 'verified':
      return 'Verified';
    case 'likely':
      return 'Likely';
    case 'reported':
      return 'Reported';
    case 'unknown':
      return 'No data';
  }
};
